import { InterpolationFragment } from '../../models';

export interface TokenParts {
    type: string;
    id: string;
    name: string;
    token: string;
    appId?: string;
}

export abstract class IInterpolationFragmentService {
    abstract convertTokenPartsToFragment(
        parts: TokenParts,
        entityId: string,
        regardingParts?: TokenParts,
    ): InterpolationFragment;
}
